import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import Provider from "./providers/Provider";
import PlaidOauthCallback from "./providers/Plaid/PlaidOauthCallback";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
});

function App() {
  return (
    <Routes>
      <Route
        path="/plaid/plaid-oauth-callback"
        element={<PlaidOauthCallback />}
      />
      <Route path="/" element={<Provider />} />
    </Routes>
  );
}

export default App;
